import {Component, Inject, Input} from 'ng-metadata/core';
import {PrimoResponse} from '../../../../infra/dataStructures/PrimoResponses/delivery.interface';
import {PrimoResponse as PR} from '../../../../infra/dataStructures/PrimoResponses/doc.interfcae';
import { AlmaOtherMembersService } from './almaOtherMembers.service';
import {PrimolyticsService,beacon} from '../../../../analytics/primolytics.service';
import {SmoothScrollUtil} from "../../../../nddUtils/smoothScrollUtil.service";
import {AnalyticsUtils} from "../../../../nddUtils/analyticsUtils.service";
import IScope = angular.IScope;
const _get= require('lodash/get');
const cloneDeep = require('lodash/cloneDeep');

export const userRegisteredToOtherInstitution = 'userRegisteredToOtherInstitution';

@Component({
	selector: 'prm-alma-other-members',
	templateUrl: 'components/search/fullView/getit/almaOtherMembers/alma-other-members.html',
})

export class PrmAlmaOtherMembers{

	public TABS = {
		INST_LIST : 0,
		OPAC: 1
	};

    @Input() public item : PR.IDoc;
    public memberItem : PR.IDoc;
    public memberInst : String;
	public memberInstName: string;
    @Input() public serviceMode: String;
    @Input() public serviceScrollId:string;
	@Input() public isOverlayFullView:boolean;
	@Input() public availabilityType: string;
	@Input() public isCollapsed: boolean;
    public registerUser : String;
	private _selectedTab = this.TABS.INST_LIST;
	private loadOtherMemberInProgress: boolean = false;
	private label : string;
	private servicesMap = {};
	private almaInstitutionsList : PrimoResponse.IDoc.delivery.almaInstitutionsList;

	constructor(
			private almaOtherMembersService: AlmaOtherMembersService,
			@Inject('$element') private element: any,
			@Inject('$timeout') private $timeout : ng.ITimeoutService,
			@Inject('I18nService') private i18nService,
			@Inject('$scope') private $scope : IScope,
			private smoothScrollUtil: SmoothScrollUtil,
			private primolyticsService: PrimolyticsService,
			private analyticsUtils: AnalyticsUtils 
			) {
				// Determine the component head label by the availability type
				if(this.availabilityType === 'E'){
					this.label = 'nui.brief.results.tabs.viewit_other';
				} else {
					this.label = 'nui.brief.results.tabs.getit_other';
				}

				// Create a local copy of pnx.delivery.almaOtherMembersService filtered with the correct availability type
				this.almaInstitutionsList = this.almaOtherMembersService.getInstitutionsFilteredByType(this.item, this.availabilityType);
				//sorting the institutions list by locale
				let interfaceLanguage = this.i18nService.getLanguage();
				let locale = (interfaceLanguage && interfaceLanguage.length > 1) ? interfaceLanguage.replace("_","-") : 'en';
				locale = locale === 'pt1' ? 'pt-PT' : locale;  // URM-231457
				const sortAgent = new Intl.Collator(locale);  
				this.almaInstitutionsList.sort((a, b) => sortAgent.compare(a.instName,b.instName));
	}

	ngOnInit(){
		this.serviceScrollId = 'alma_other_members'; //this way focus will move to geit from other locations and not to regular get it after clicking on locations

		this.$scope.$on(userRegisteredToOtherInstitution, (event, memberInst) => {
			const otherInst = this.almaInstitutionsList.find(inst => inst.instCode === memberInst);
			if(otherInst) {
				this.loadOtherMember(otherInst);
			}
		});
	}

	public getInstitutions(){
		return this.almaInstitutionsList;
	
	}

	get selectedTab() {
		return this._selectedTab;
	}
	set selectedTab(tab) {
		this._selectedTab = tab;
	}

	public loadOtherMember(almaInst : PrimoResponse.Delivery.IMoreAlmaInstitution){
		this.memberInst = almaInst.instCode;
		this.memberInstName = _get(almaInst, 'instName', 'other institution');
		this.loadOtherMemberInProgress = true;
		if(this.item.context === 'v2v'){
			let v2vData = cloneDeep(this.item);
			v2vData.delivery = this.item.otherInstDelivery;
			v2vData.delivery.almaInstitutionsList = cloneDeep(this.item.delivery.almaInstitutionsList);
			this.memberItem = v2vData;
			this.almaOtherMembersService.getLinkedAccountCreationOption(this.memberInst, v2vData.delivery.almaInstitutionsList[0].envURL)
				.then((res) => {
					this.registerUser = _get(res,"registerUser","None");
				}).finally(() => {
					this.loadOtherMemberInProgress = false;
			});
		} else {
			this.almaOtherMembersService.loadOtherMember(almaInst, this.availabilityType)
				.then((response) => {
					this.setOtherMemberScrollWatcher();
					if(this.availabilityType === 'P'){
						let data = response.data[0];
						this.memberItem = data;
						this.registerUser = _get(data,"registerUser","None");
					} else if(this.availabilityType === 'E'){
						this.memberItem = response.data;
						this.servicesMap = this.almaOtherMembersService.initializeViewitOtherServicesMap(this.memberItem);
					} else {
						console.error('The type ' + this.availabilityType + 'is not supported as an availability type for other members');
					}
				}).finally(() => {
				this.loadOtherMemberInProgress = false;
			})
		}
	}

	private setOtherMemberScrollWatcher(){
		this.$timeout(() => {
			let deregisterWatcher1 = this.$scope.$watch(()=>this.loadOtherMemberInProgress, (newVal, oldVal)=> {
				if (!newVal){
					deregisterWatcher1();
					let deregisterWatcher2 = this.$scope.$watch(()=>{return this.element[0].querySelector('prm-location')}, (locationElement)=>{
						if (locationElement){
							if (this.isOverlayFullView) {
								this.smoothScrollUtil.scrollTo(locationElement, '', 'sticky-scroll');
							}
							else {
								this.smoothScrollUtil.scrollTo(locationElement, '', '');
							}
							deregisterWatcher2();
						}
					});
				}
			});
			if (this.isOverlayFullView) {
				this.smoothScrollUtil.scrollTo(this.serviceScrollId, '', 'sticky-scroll');
			}
			else {
				this.smoothScrollUtil.scrollTo(this.serviceScrollId, '', '');
			}
		}, 0, false);
	}

	public collapseSection(event) {
		if(this.isCollapsed && this.availabilityType === 'E'){
			this.callViewitOtherBeacon();
			this.sendAnalytics();
		}
		this.isCollapsed = !this.isCollapsed;
        let elem = event.target;
        elem.setAttribute('aria-expanded', this.isCollapsed);
    }

	// ------------------------ Getit other ----------------------------------

	get opacRequestInProgress(){
    	return this.almaOtherMembersService.opacRequestInProgress();
	}

	// ------------------------ Viewit other ----------------------------------

	get servicesList(){
        return this.almaOtherMembersService.getServicesList();
	}
	
	/**
	 * Returns the services from the REST call filtered by the service type (E / D) for the View-it-items component
	 * @param serviceType The service type (E / D)
	 */
	public getServices(serviceTypeName : string){
		if(this.servicesMap[serviceTypeName]){
			return this.servicesMap[serviceTypeName];
		}
	}

	@beacon({'p':'brief', 'op':'checkOnlineFromOthers'})
	private callViewitOtherBeacon(){

	}

	private sendAnalytics() {
        let payload = this.getAnalyticsPayload();
        this.analyticsUtils.trackUsage(this.analyticsUtils.eventsNames.ONLINE_RESOURCE_LINK, payload);
    }

    private getAnalyticsPayload() {
        return {
			'Online Resource Link Type': 'Check Consortium Institutions',
			'Displayed Link Name': this.label,
			"Record ID": _get(this.item, 'pnx.control.recordid[0]'),
			"Record Title": _get(this.item, 'pnx.display.title[0]'),
			"Resource Type": _get(this.item, 'pnx.display.type[0]')
        }
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/getit/almaOtherMembers/almaOtherMembers.directive.ts